import { EyeOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Col, Row, Tooltip } from 'antd';
import { Text, Box } from 'atoms';
import { StatusAction } from 'components';
import { ACL } from 'components/common';
import { getLocalDate, getLocalTime } from 'utils/helpers';
import { getVRF } from 'store/vendorBillSlice';

const pdf = 'pdf';
const docx = 'docx';

export const VendorTableConfig = [
	{
		title: 'Vendor Name',
		dataIndex: 'vendor_info',
		key: 'vendor_info',
		hidden: false,
		render: (vendor_info) => <Text overFlow="hidden">{vendor_info?.vendor_name || ''}</Text>,
	},
	{
		title: 'Mobile Number  ',
		dataIndex: 'vendor_info',
		key: 'vendor_info',
		hidden: false,
		render: (vendor_info) => <Text overFlow="hidden">{vendor_info?.mobile_number || ''}</Text>,
	},
	{
		title: 'City',
		dataIndex: 'vendor_info',
		key: 'vendor_info',
		hidden: false,
		render: (vendor_info) => <Text overFlow="hidden">{vendor_info?.city || ''}</Text>,
	},
	{
		title: 'Address',
		dataIndex: 'vendor_info',
		key: 'vendor_info',
		width: '20%',
		hidden: false,
		render: (vendor_info) => <Text overFlow="hidden">{vendor_info?.address || ''}</Text>,
	},
	{
		title: 'username',
		dataIndex: 'username',
		key: 'username',
		hidden: false,
		render: (username) => <Text overFlow="hidden">{username || ''}</Text>,
	},
	{
		title: 'Vendor Type',
		dataIndex: 'vendor_type',
		key: 'vendor_type',
		hidden: false,
		render: (vendor_type) => <Text overFlow="hidden">{vendor_type || ''}</Text>,
	},
	{
		title: 'Created at',
		dataIndex: 'created_at',
		key: 'created_at',
		hidden: false,
		render: (created_at) => (
			<Box>
				<Text overFlow="hidden">{getLocalDate(created_at)}</Text>

				<Text overFlow="hidden" fontStyle="italic">
					{getLocalTime(created_at)}
				</Text>
			</Box>
		),
	},
	{
		title: 'VRF',
		dataIndex: 'id',
		key: 'id',
		width: '8%',
		hidden: false,
		render: (id) => (
			<Row gutter={16}>
				<Col>
					<Col>
						<Tooltip title="Download VRF">
							<FilePdfOutlined
								style={{
									color: 'red',
									fontSize: '14px',
								}}
								onClick={getVRF({ id, type: pdf })}
							/>
						</Tooltip>
					</Col>
				</Col>
				<Col>
					<Tooltip title="Download DOC">
						<FilePdfOutlined
							style={{
								color: 'blue',
								fontSize: '14px',
							}}
							onClick={getVRF({ id, type: docx })}
						/>
					</Tooltip>
				</Col>
			</Row>
		),
	},
	{
		title: 'View',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		width: '5%',
		render: (id) => (
			<Row gutter={8} justify="space-between">
				<Col>
					<Link to={`/vendor/edit/${id}`}>
						<EyeOutlined />
					</Link>
				</Col>
			</Row>
		),
	},
	{
		title: 'Action',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id, record) => (
			<ACL action="update" module="vendor">
				<StatusAction statusData={record?.is_active} userType="vendor" id={id} />
			</ACL>
		),
	},
];
